"use client";

import React, { useState, useEffect } from "react";
import { officialUrl, registerUrl } from "@/constants/api";
import {
  firstActiveIconList,
  firstNavIconList,
  headerNavOut,
  registers,
} from "@/constants/header";
import { Col, Collapse, Drawer, Row } from "antd";
import { getInnerWidth } from "@/utils/commonHooks";
import _ from "lodash";

import logo from "@/assets/images/newheader/logo.svg";
import arr_icon from "@/assets/images/header/arr_icon.svg";
import arr_icon_active from "@/assets/images/header/arr_icon_active.svg";
import close_icon from "@/assets/images/header/close_icon.svg";
import menu_icon from "@/assets/images/newheader/menu-icon.svg";
import mobile_logo from "@/assets/images/newheader/mobile_logo.png";
import three_nav_icon from "@/assets/images/header/three_nav_icon.svg";

import "./index.scss";

const { Panel } = Collapse;
interface navProps {
  title: string;
  href?: string;
  id?: string;
  colSpan?: number;
  threeRank?: boolean;
  children: any[];
}

interface navChildProps {
  title: string;
  href: string;
  icon?: string;
  children?: any[];
}

const NewHeader = () => {
  const [isopen, setOpen] = useState(false);
  const [firstNavKey, setFirstNavKey] = useState<string | string[]>([]);
  const [secondNavKey, setSecondNavKey] = useState<string | string[]>([]);
  const [scrollHeight, setScrollHeight] = useState(0);
  const pcWidth = getInnerWidth();

  function showMenu() {
    setOpen(true);
  }
  function onClose() {
    setOpen(false);
  }
  function changeNavKey(type: string, activeKey: string | string[]) {
    if (type === "firstNav") {
      setFirstNavKey(activeKey);
    } else {
      setSecondNavKey(activeKey);
    }
  }

  function goRegister() {
    window.open(registers, "_self");
  }

  useEffect(() => {
    window.addEventListener("scroll", function () {
      const scrollHeight =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      setScrollHeight(scrollHeight);
    });
    return window.removeEventListener("scroll", function () {
      const scrollHeight =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      setScrollHeight(scrollHeight);
    });
  });

  return (
    <div className={`header-wrapper ${scrollHeight > 24 && "has-fixed"}`}>
      <a href={officialUrl} className="logo">
        <img src={pcWidth === "pc" ? logo.src : mobile_logo.src} alt="" />
      </a>
      <div className="menu-items">
        <ul className="header-right">
          {headerNavOut("pc").map((nav: navProps, key: number) => {
            if (nav.threeRank) {
              return (
                <li key={key} className={`noRelative `}>
                  <span className="firstTit">{nav.title}</span>
                  <div className={`menu-second`}>
                    {/* <div className="wrapper hCenter"> */}
                    {_.get(nav, "children", []).length > 0 && (
                      <Row gutter={60} align={"top"} justify={"end"}>
                        {nav.children.map((c: navChildProps, i: number) => {
                          return (
                            <Col key={i} span={nav.colSpan}>
                              <h6>
                                <img src={c.icon} />
                                <span>{c.title}</span>
                              </h6>
                              {_.get(c, "children", []).map(
                                (t: navChildProps, k: number) => {
                                  return (
                                    <p key={k}>
                                      <a href={t.href}>{t.title}</a>
                                    </p>
                                  );
                                }
                              )}
                            </Col>
                          );
                        })}
                      </Row>
                    )}
                    {/* </div> */}
                  </div>
                </li>
              );
            } else {
              return (
                <li key={key}>
                  {!nav.href ? (
                    <span className="firstTit">{nav.title}</span>
                  ) : (
                    <a href={nav.href} className="firstA">
                      {nav.title}
                    </a>
                  )}
                  {_.get(nav, "children", []).length > 0 && (
                    <div
                      className={`menu-hd ${
                        nav.id && nav.id == "product" ? "menu-pro-hd" : ""
                      }`}
                    >
                      {nav.children.map((c: navChildProps, i: number) => {
                        return (
                          <a href={c.href} key={i}>
                            {c.title}
                          </a>
                        );
                      })}
                    </div>
                  )}
                </li>
              );
            }
          })}
        </ul>
        <div className="menu_icon" onClick={showMenu}>
          <img src={menu_icon.src} alt="" />
        </div>
        <button className="menu-item-register" onClick={goRegister}>
          立即注册
        </button>
      </div>
      <Drawer
        className="customDrawer"
        placement="right"
        closable={false}
        onClose={onClose}
        style={{ width: "100%" }}
        open={isopen}
        zIndex={2147483648}
        title={
          <div className="mobile_logo">
            <img src={mobile_logo.src} alt="" className="logo" />
            <span onClick={onClose}>
              <img src={close_icon.src} className="close_icon" />
            </span>
          </div>
        }
      >
        {headerNavOut("pc").map((nav: navProps, key: number | string) => {
          if (nav.children.length > 0) {
            return (
              <Collapse
                ghost={true}
                accordion={true}
                expandIconPosition={"end"}
                key={key}
                activeKey={firstNavKey}
                onChange={changeNavKey.bind(null, "firstNav")}
                expandIcon={({ isActive }) => (
                  <img src={isActive ? arr_icon_active.src : arr_icon.src} />
                )}
              >
                {nav.threeRank ? (
                  <Panel
                    header={
                      <div className="firstNavTit">
                        <img
                          src={
                            key === Number(firstNavKey[0])
                              ? _.get(firstActiveIconList, firstNavKey[0])
                              : firstNavIconList[Number(key)]
                          }
                        />
                        <span>{nav.title}</span>
                      </div>
                    }
                    key={key}
                  >
                    {nav.children.map((c: navChildProps, i: number) => {
                      return (
                        <Collapse
                          className="secondNavCollapse"
                          activeKey={secondNavKey}
                          onChange={changeNavKey.bind(null, "secondNav")}
                          ghost={true}
                          accordion={true}
                          expandIconPosition={"end"}
                          key={i + "second"}
                          expandIcon={({ isActive }) => (
                            <img
                              src={
                                isActive ? arr_icon_active.src : arr_icon.src
                              }
                            />
                          )}
                        >
                          <Panel
                            header={
                              <div className="secondNavTit">
                                <img src={c.icon} />
                                <span>{c.title}</span>
                              </div>
                            }
                            key={i}
                          >
                            {_.get(c, "children", []).map(
                              (d: any, k: number) => {
                                return (
                                  <p key={k}>
                                    {!d.href ? (
                                      d.title
                                    ) : (
                                      <a href={d.href}>
                                        <img src={three_nav_icon.src} />
                                        <span>{d.title}</span>
                                      </a>
                                    )}
                                  </p>
                                );
                              }
                            )}
                          </Panel>
                        </Collapse>
                      );
                    })}
                  </Panel>
                ) : (
                  <Panel
                    header={
                      <div className="firstNavTit">
                        <img
                          src={
                            key === Number(firstNavKey[0])
                              ? _.get(firstActiveIconList, firstNavKey[0])
                              : firstNavIconList[Number(key)]
                          }
                        />
                        <span>{nav.title}</span>
                      </div>
                    }
                    key={key}
                  >
                    {nav.children.map((c: navChildProps, i: number) => {
                      return (
                        <p key={i}>
                          {!c.href ? (
                            c.title
                          ) : (
                            <a href={c.href}>
                              <img src={three_nav_icon.src} />
                              <span>{c.title}</span>
                            </a>
                          )}
                        </p>
                      );
                    })}
                  </Panel>
                )}
              </Collapse>
            );
          } else {
            return (
              <div className="navLi" key={key}>
                <a href={nav.href}>
                  <img src={_.get(firstNavIconList, key)} />
                  <span>{nav.title}</span>
                </a>
              </div>
            );
          }
        })}
      </Drawer>
    </div>
  );
};
export default NewHeader;
